import * as React from 'react';
import { KAttachment, KComplements } from '../';
import { Utils } from '../../core/utils';
import { ControlModel } from '../../models/index';
import { IDispatcher } from '../../abstraction';

interface IProps {
	Control: ControlModel,		// La zone x3 correspondante
	dispatcher: IDispatcher;	// Dispatcher g�n�ral
	ShowEmbedded?: boolean;
}

// Composant repr�sentant une Zone de type document (ControlTypeEnum.document)
// 
export class KControlAttachment extends React.Component<IProps> {
	public constructor(props: any) {
		super(props);
	}

	// Call back appel� une fois l'upload d'un fichier effectu�
	// path : contient le nom du fichier
	onUploadComplete = (path) => {
		this.props.Control.Value = path;
		this.forceUpdate();
	}

	//#region Rendus

	render() {
		let ctrl = this.props.Control;
		if (!ctrl.Visible) return null;

		let inlineStyle = Utils.decodeInlineStyleFromJson(ctrl.InlineStyle);
		let bsSize = Utils.getColSizeClasses(ctrl);

		// Contient donc le composant g�rant les pi�ces jointes + l es compl�ments
		return (
			<div className={`KControl KControlAttachment ${ctrl.Class} ${bsSize}`} style={inlineStyle} >
				<KAttachment
					onFileRemoved={() => {
						this.props.Control.Value = "";
						this.forceUpdate();
					}}
					embedded={this.props.ShowEmbedded}
					drawMode={ctrl.DrawMode}
					msgboxProvider={this.props.dispatcher}
					imageProvider={this.props.dispatcher}
					camera={ctrl.Camera}
					onUploadComplete={(path) => { this.onUploadComplete(path) }}
					path={ctrl.Value}
					visible={ctrl.Visible}
					description={ctrl.Description}
					showMoreIcon={ctrl.ShowMoreIcon} />

				<KComplements Control={ctrl} />
			</div>
		)
	}

	//#endregion 
}